<template>
  <section
    data-background-image="/img/presentationbackgrounds/scorecard.jpeg"
    data-background-opacity="0.4"
  >
    <section
      id="scorecardSlide"
      v-for="area in scorecardData"
      :key="'scorecard-' + area.areaname"
    >

    
      <div
        class="sl-block"
        data-block-type="text"
        style="width: 100%; left: 29px; top: 84px; height: auto"
      >
        <div
          class="sl-block-content"
          data-placeholder-tag="h2"
          data-placeholder-text="Title Text"
          style="text-align: left; z-index: 10"
          dir="ui"
        >
          <h2 style="text-align:center">{{ area.areaname }} Scorecard</h2>
        </div>
      </div>

      <div
        class="sl-block"
        data-block-type="table"
        style="
          height: auto;
          min-width: 120px;
          width: 100%;
          left: 29px;
          top: 175.5px;
        "
      >
        <table>
          <tbody>
            <tr>
              <td>Temps</td>
              <td>
                {{ area.temps.tempMin }} | {{ area.temps.tempAverage }} |
                {{ area.temps.tempMax }}
              </td>
            </tr>

            <tr>
              <td>Humidity</td>
              <td>
                {{ Math.round(area.rh.minReading * 100) }}% |
                {{ Math.round(area.rh.current * 100) }}% |
                {{ Math.round(area.rh.maxReading * 100) }}%
              </td>
            </tr>

            <tr>
              <td>CO2 Levels</td>
              <td>
                {{ area.co2.min }} | {{ area.co2.avg }} | {{ area.co2.max }} ppm
              </td>
            </tr>

            <tr>
              <td>Empty VFUs</td>
              <td>
                {{
                  area.growPlatformsCount.platformGroupCount -
                  area.growPlatformsInUse.platformsInUseCount
                }}
              </td>
            </tr>
            <tr>
              <td>Clones</td>
              <td>{{ area.clonePlants }}</td>
            </tr>
            <tr>
              <td>Plants in Veg</td>
              <td>{{ area.vegPlants }}</td>
            </tr>

            <tr>
              <td>Plants in Flower</td>
              <td>{{ area.flowerPlants }}</td>
            </tr>

            <tr>
              <td>Open Tkts</td>
              <td>{{ area.tickets }}</td>
            </tr>

            <td>Disabled Units</td>
            <td>{{ area.disabledUnits }}</td>
          </tbody>
        </table>
      </div>
    </section>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Scorecard from "@/mixins/Scorecard.js";

export default {
  name: "",
  props: ["value"],
  mixins: [Scorecard],
  components: {},
  beforeMount() {
    this.refresh();
  },
  mounted() {},
  data() {
    return {
      scorecardData: [],
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {
      let me = this;
      this.getStats(this.getUser, function (res) {
        me.scorecardData = res;
      });
    },
  },
};
</script>
<style>
#scorecardSlide td {
  font-size: 0.8em;
}
</style>

